import LoginForm, { FormModel } from "./form";
import { useNavigate } from "react-router";
import { loginAdmin } from "stores/actions/auth";
import { showError, showGenericError } from "lib/notification";
import { useState } from "react";
import LoginView from "components/layout/login-view";
import { cast, FormValues } from "lib/form";
import Line from "components/layout/line";
import { adminDoPostSignicatSessions } from "services/signicat";
import Signicat from "components/signicat";
import { useLocale } from "stores/hooks/locale";
import { useTranslate } from "stores/hooks/translation";

const AdminLoginView = () => {
  const [transition, toggleTransition] = useState(false);
  const locale = useLocale();
  const translate = useTranslate();

  const navigate = useNavigate();

  const tryLogin = async (values: FormValues) => {
    const vals = cast<FormModel>(values);
    const { email, password } = vals;

    try {
      // try login
      await loginAdmin(email, password);

      // start animation
      toggleTransition(true);

      // redirect to root route
      setTimeout(() => navigate("/admin"), 500);
    } catch (err) {
      // login failed, show error
      showError(translate("login_error"));
    }
  };

  const handleSignicat = async () => {
    try {
      const response = await adminDoPostSignicatSessions(locale);
      const { authenticationUrl } = response;
      window.location.href = authenticationUrl;
    } catch (err) {
      showGenericError();
    }
  };

  return (
    <LoginView title={translate("login_title")} transition={transition}>
      <LoginForm onSubmit={tryLogin} />
      <Line text={translate("login_or")} />
      <Signicat onClick={handleSignicat} />
    </LoginView>
  );
};

export default AdminLoginView;
